import { render, staticRenderFns } from "./ProductsListAddNew.vue?vue&type=template&id=27b1e856&"
import script from "./ProductsListAddNew.vue?vue&type=script&lang=js&"
export * from "./ProductsListAddNew.vue?vue&type=script&lang=js&"
import style0 from "./ProductsListAddNew.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports